import ListClient from './ListClient';
import { List } from '../../domain/list/ListDomains';
import HttpClient from '../../gateway/HttpClient';
import { notBlank, notUndefined } from '../../util/Assert';
import HttpMethod from '../../constant/HttpMethod';
import { ListMethods } from '../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import { ActionType } from '../../constant/Constants';

class NestListClient implements ListClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public remove(name: string): Promise<void> {
    notUndefined(name, 'Name cannot be undefined');
    notBlank(name, 'Name cannot be blank');
    return this.httpClient.execute(HttpMethod.DELETE, `${ListMethods.REMOVE}/${name}`);
  }

  public save(list: List): Promise<void> {
    notUndefined(list, "List cannot be undefined");
    
    const cleanList = { ...list };
    if (cleanList.hasOwnProperty('productType')) {
      delete (cleanList as any).productType;
    }
    
    const dto = {id: cleanList.name, object: cleanList};
    return this.httpClient.execute(HttpMethod.POST, ListMethods.SAVE, dto)
  }

  public deploy(name: string): Promise<void> {
    notUndefined(name, 'Name cannot be undefined');
    notBlank(name, 'Name cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${ListMethods.DEPLOY}/${name}`);
  }

  public undeploy(name: string): Promise<void> {
    notUndefined(name, 'Name cannot be undefined');
    notBlank(name, 'Name cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${ListMethods.UNDEPLOY}/${name}`);
  }

  public getCount(_query: query.Query): Promise<number> {
    notUndefined(_query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.POST, ListMethods.COUNT, _query);
  }

  public exist(id: string): Promise<boolean> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${ListMethods.EXIST}/${id}`);
  }

  public findById(id: string): Promise<List | undefined> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${ListMethods.GET}/${id}`);
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, ListMethods.BULK_ACTION, payload);
  }
}

export default NestListClient;
